import * as moment from 'moment';
import i18n from '@/plugins/i18n';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { BusinessBookingRequestPostConfiguration } from './business-booking-request-post-configuration';

export class BusinessBookingRequest {
    public id: number = 0;
    public consumerName?: string;
    public code?: string;
    public createdUtc?: moment.Moment;
    public referenceTitle?: string;
    public referenceDescription?: string;
    public referenceThumbnailImageUrl?: string;
    public businessTradeName?: string;
    public referencePrice: number | null = null;
    public referencePriceDetails?: string;
    public referenceDiscountedPrice: number | null = null;
    public referencePostConfiguration: BusinessBookingRequestPostConfiguration | null = null;
    public buyerName?: string;
    public buyerEmail?: string;
    public buyerPhone?: string;
    public remarks?: string;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.BusinessBookingRequests;
    }

    public get permissionsIdToCheck(): number {
        return this.id;
    }

    public get created(): moment.Moment | undefined {
        return this.createdUtc ? this.createdUtc.local() : undefined;
    }

    get referenceHtmlTitle(): string | undefined {
        let content: string = '';
        if (this.referenceTitle) {
            content += `<span class="title">${this.referenceTitle}</span>`;
        } else if (this.referenceDescription) {
            content += `<div class="description long-text-container">${this.referenceDescription}</div>`;
        } else if (this.referenceThumbnailImageUrl) {
            content += `<img src="${this.referenceThumbnailImageUrl}" class="thumbnail"/>`;
        } else {
            content = '???';
        }
        if (this.referencePostConfiguration && this.referencePostConfiguration.bookable) {
            if (this.referencePostConfiguration.startingDateUtc) {
                content += `<br/><small><i class="mdi mdi-calendar-start mr-1"></i> ${i18n.d(new Date(this.referencePostConfiguration.startingDateUtc), 'compact')}</small>`;
            }
            if (this.referencePostConfiguration.endingDateUtc) {
                content += `<br/><small><i class="mdi mdi-calendar-end mr-1"></i> ${i18n.d(new Date(this.referencePostConfiguration.endingDateUtc), 'compact')}</small>`;
            }
            if (this.referencePostConfiguration.location) {
                content += `<br/><small><i class="mdi mdi-map-marker mr-1"></i> ${this.referencePostConfiguration.location}</small>`;
            }
        }
        return content;
    }

    get referenceFormattedPrice(): string | undefined {
        let result: string = '';

        if (this.referencePrice) {
            if (this.referenceDiscountedPrice) {
                result += `<small class="old-price mr-1"><del>${i18n.n(this.referencePrice, 'currency')}</del></small>`;
            } else {
                result += `<span class="current-price">${i18n.n(this.referencePrice, 'currency')}</span>`;
            }
        }

        if (this.referenceDiscountedPrice != null) {
            result += `<span class="discounted-price">${i18n.n(this.referenceDiscountedPrice, 'currency')}</span>`;
        }

        return '<span class="price">' + result + '</span>' + (this.referencePriceDetails ? '<br/><small><span class="price-details">' + this.referencePriceDetails + '</span></small>' : '');
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            createdUtc: moment.utc(json.createdUtc),
            referencePostConfiguration: json.referencePostConfiguration ? new BusinessBookingRequestPostConfiguration(json.referencePostConfiguration) : null
        });
    }
}
